var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      staticClass: "ui-lightbox-button",
      attrs: { for: _vm.target, id: _vm.id },
      on: {
        click: function($event) {
          _vm.$root.lightboxButtonClick($event, _vm.target),
            _vm.youtubeLoad(_vm.target, _vm.youtubeId)
        }
      }
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }